import { Rout_create } from './Rout.create'
import { Rout_to } from './Rout'
import { Rout_setBack } from './Rout.back'
import type { Post_TPostId } from '../Post/Post.TPost'

export interface Rout_ProcedureRoutesArgs {
    Proc_ContentPage: React.FunctionComponent<unknown>
}

export const Rout_procedureContentPageRoutePattern = '/procedure/content/:procedureId'

export const Rout_ProcedureRoutes = (args: Rout_ProcedureRoutesArgs) => [
    Rout_create(Rout_procedureContentPageRoutePattern, args.Proc_ContentPage),
]

export function Rout_toProcedureContentPage(procedureId: number, back?: () => void, query?: { postId?: Post_TPostId }) {
    Rout_setBack(back)
    Rout_to(`/procedure/content/${procedureId}`, query)
}
